import { ESTADOS_RESERVA, EstadosPagoReserva } from 'src/constants/reservaConstants';

const palette = {
  green: { bgColor: '#92FF9C', textColor: '#008E0E' },
  blue: { bgColor: '#B9EEFF', textColor: '#0074A6' },
  purple: { bgColor: '#E599FF', textColor: '#730099' },
  yellow: { bgColor: '#FFD633', textColor: '#997A00' },
  red: { bgColor: '#FFCCCC', textColor: '#FF0000' },
  orange: { bgColor: '#FFBF59', textColor: '#C63C00' },
  lightGreen: { bgColor: '#DDFF9E', textColor: '#75B400' },
  pink: { bgColor: '#FDB8FF', textColor: '#E700EF' },
  grey: { bgColor: '#D6E5EA', textColor: '#587B86' },
};

export const estadosTags = {
  AdministracionReservaService: {
    [EstadosPagoReserva.PAGOS_PENDIENTES]: palette.yellow,
    [EstadosPagoReserva.PAGOS_AL_DIA]: palette.purple,
    [EstadosPagoReserva.TOTALMENTE_PAGADA]: palette.green,
    [EstadosPagoReserva.INSCRIPCION]: palette.green,
    [ESTADOS_RESERVA.ABANDONADA]: palette.pink,
    [ESTADOS_RESERVA.BLOQUEADA]: palette.orange,
    [ESTADOS_RESERVA.CANCELADA]: palette.red,
    [ESTADOS_RESERVA.RESERVADA]: { bgColor: null, textColor: null },
  },
};

const ESTADO_CHIP_LABEL_KEYS = {
  [EstadosPagoReserva.PAGOS_PENDIENTES]: 'staff.misClientes.estadoChip.PAGOS_PENDIENTES',
  [EstadosPagoReserva.PAGOS_AL_DIA]: 'staff.misClientes.estadoChip.PAGOS_AL_DIA',
  [EstadosPagoReserva.TOTALMENTE_PAGADA]: 'staff.misClientes.estadoChip.TOTALMENTE_PAGADA',
  [EstadosPagoReserva.INSCRIPCION]: 'staff.misClientes.estadoChip.INSCRIPCION',
  [ESTADOS_RESERVA.ABANDONADA]: 'staff.misClientes.estadoChip.ABANDONADA',
  [ESTADOS_RESERVA.BLOQUEADA]: 'staff.misClientes.estadoChip.BLOQUEADA',
  [ESTADOS_RESERVA.CANCELADA]: 'staff.misClientes.estadoChip.CANCELADA',
  [ESTADOS_RESERVA.RESERVADA]: 'staff.misClientes.estadoChip.RESERVADA',
};

export function getEstadoReservaChip(estado) {
  const colors = estadosTags.AdministracionReservaService[estado] ?? { bgColor: null, textColor: null };

  return {
    value: estado,
    labelKey: ESTADO_CHIP_LABEL_KEYS[estado],
    bgColor: colors.bgColor,
    textColor: colors.textColor,
  };
}
